import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { BetaBadge } from "@/ui/Badges/BetaBadge";
import { AnnieMenuLabel } from "./AnnieMenuLabel";

/** The Annie menu row's label with its beta badge — one copy for the hamburger and the gaps-first More sheet. */
export const AnnieMenuRowLabel: FC = () => {
	const { t } = useTranslation();
	return (
		<Box component="span" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<AnnieMenuLabel />
			<BetaBadge label={t("annie.beta.badge")} dataTestId="annie-nav-beta-badge" />
		</Box>
	);
};
